export class UpdateLinkRegistryError extends Error {
}